// extracted by mini-css-extract-plugin
var _1 = "FeedThread_root__0d668";
var _2 = "FeedThread_title__5bd0f";
export { _1 as "root", _2 as "title" }
